import { render } from "./inputwithcompression.vue?vue&type=template&id=1053c9b8"
import script from "./inputwithcompression.vue?vue&type=script&lang=js"
export * from "./inputwithcompression.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__